import PropTypes from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';

export default class PermissionWrapper extends React.Component {
    static propTypes = {
        /**
         * components that will be rendered if user has permissions
         */
        children: PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.arrayOf(PropTypes.node),
        ]).isRequired,
        /**
         * whether the user has permission or not
         */
        hasPermission: PropTypes.bool.isRequired,
        /**
         * url that will be redirected to if hasPermission is false
         */
        redirectTo: PropTypes.string,
    };

    static defaultProps = {
        hasPermission: false,
        redirectTo: '/',
    };

    render() {
        const { hasPermission, redirectTo, children } = this.props;

        if (hasPermission) {
            return children;
        }
        return <Redirect to={redirectTo} />;
    }
}
